import * as React from "react";
import { useEffect, useState } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useStyles } from "../../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,FormHelperText,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import PopUp from "../../popup/PopUp";
import { externalpostApi, externalgetApi } from "../../../services/externalApis";
import { useSelector } from "react-redux";
import { GRN_API_11, GRN_API_19, SETTING_API_17 } from "../../../api/ApiModel";

import { BUTTON_LABELS, ITEM_LABELS } from "../../../utils/sys/GrnLabels";
import { GRN_STATUS } from "../../../utils/sys/GrnConstants";
import {
  CON_BUSINESS_TYPECODE,
  CON_GRN_STATUS_RETURN,
  CON_GRN_STATUS_REVOKE,
  CON_STATUS_ACTIVE,
  CON_STATUS_RETURN_SUBMITTED,
  CON_STATUS_RETURNAPPROVED,
  CON_STATUS_RETURNREJECTED,
} from "../../../utils/sys/Constants";
import { AnyForNow } from "../../../features/grn/types";


//  Map actionType → reasoncatcode
const REASON_CATCODE_MAP = {
  Approve: "8",
  Reject: "9",
  Return: "6",
};

interface ApprovalActionDialogreturnProps {
  open: boolean;
  handleClose: () => void;
  actionType: string;
  grnCodes?: string[];
  enUser?: AnyForNow;
  onSuccess?: () => void;
  resattachments?: AnyForNow[];
  rtncodes?: string[];
}

const ApprovalActionDialogreturn: React.FC<ApprovalActionDialogreturnProps> = ({
  open,
  handleClose,
  actionType,
  grnCodes = [],
  enUser,
  onSuccess,
  resattachments = [],
  rtncodes = [],
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [isChecked, setIsChecked] = useState(false);
  const [documentType, setDocumentType] = useState("");
  const [remark, setRemark] = useState("");
  const [reason, setReason] = useState("");
  const [reasonOptions, setReasonOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const SYS_USER = useSelector((state: any) => state.user) || {};
   const { LOCCODE, STAFFMAPLOCODE, RESTCODE, USERNAME, COMPCODE } =
    SYS_USER.USER_PARAM || {};
const [reasonError, setReasonError] = useState(false);

  // Reset when dialog closes
  useEffect(() => {
    if (!open) {
      setIsChecked(false);
      setDocumentType("");
      setRemark("");
      setReason("");
      setReasonError(false);
    }
  }, [open]);

  //  Fetch reason options based on actionType
  useEffect(() => {
    const fetchReasons = async () => {
      if (!actionType) return;

      const reasoncatcode = REASON_CATCODE_MAP[actionType];
      if (!reasoncatcode) return;

      setLoading(true);
      try {
        const result = await externalgetApi(SETTING_API_17, "get", {
          COMPCODE,
             LOCCODE: STAFFMAPLOCODE,
          reasoncatcode,
          STS: CON_STATUS_ACTIVE,
        });
        console.log(`API result for ${reasoncatcode}:`, result);
        setReasonOptions(result || []);
      } catch (error) {
        console.error("Error fetching reason options:", error);
        setReasonOptions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchReasons();
  }, [actionType, COMPCODE, LOCCODE]);

 const handleSubmit = async () => {

   if (actionType === BUTTON_LABELS.REJECT && !reason) {
    setReasonError(true);   // ← trigger error display
    return;                 // ← stop submission
  }
  setReasonError(false);

const statusCode =
  actionType === BUTTON_LABELS.APPROVE
    ? CON_STATUS_RETURNAPPROVED
    : actionType === BUTTON_LABELS.REJECT
    ? CON_STATUS_RETURNREJECTED
    : actionType === BUTTON_LABELS.RETURN
    ? CON_STATUS_RETURN_SUBMITTED
    : "";
// ...existing code...



const payload = {
grnBulkStsDet: grnCodes.map((grncode, index) => ({
  grncode: grncode || "",
  grnreturncode: rtncodes?.[index] || "",
  descrip: remark,
  reason: reason,
  enuser: USERNAME,
  documents: "",
  sts: statusCode,
  trsts: statusCode,
  dtoReasonDOCs:
    resattachments?.length > 0
      ? resattachments.map((att) => ({
          doctypecode: att.doctypecode || "",
          doctypeothername: att.doctypeothername || "",
          docpathjson: att.docpathjson || "",
          filename: att.fileName || "",
          bytarr: att.docpathjson || "",
          remark: att.remark || att.docremark || "",
        }))
      : [
          {
            doctypecode: "",
            doctypeothername: "",
            docpathjson: "",
            filename: "",
            bytarr: "",
            remark: "",
          },
        ],
})),
  compcode: COMPCODE || "",
  businesstypecode: CON_BUSINESS_TYPECODE, // Replace with your actual business type code if needed
};

  console.log("Bulk Payload:", payload);

  try {
    const response = await externalpostApi(GRN_API_19, payload);
    console.log("Bulk Response:", response);

    handleClose();
    onSuccess?.();
  } catch (error) {
    console.error("Error submitting approval:", error);
  }
};

  const getTitle = () => {
    switch (actionType) {
      case BUTTON_LABELS.APPROVE:
        return "Purchases  Return Approval";
      case BUTTON_LABELS.REJECT:
        return "Purchases  Return Rejection";
      case "Return":
        return "Purchases  Return";
      default:
        return "Action";
    }
  };

  const getReasonLabel = () => {
    switch (actionType) {
      case BUTTON_LABELS.APPROVE:
        return "Reason for Approval";
      case BUTTON_LABELS.REJECT:
        return "Reason for Rejection";
      case "Return":
        return "Reason for Return";
      default:
        return ITEM_LABELS.REASON;
    }
  };

  const content = (
    <Box>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
        <FormControl variant="outlined" fullWidth size="small" error={reasonError}>
  <InputLabel>{getReasonLabel()}</InputLabel>
  <Select
    value={reason}
  onChange={(e) => {
      setReason(e.target.value);
      setReasonError(false);   // ← clears error as soon as user picks something
    }}
    label={getReasonLabel()}
    disabled={loading}
    
  >
    {reasonOptions.map((option, index) => (
      <MenuItem
        key={index}
        value={option.descrip || option}
      >
        {option.descrip || option}
      </MenuItem>
    ))}
  </Select>
  {reasonError && (
    <FormHelperText sx={{ fontSize: 12, color: "error.main" }}>
      Reason is required for rejection
      </FormHelperText>
  )}
</FormControl>
        </Grid>

        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            id={ITEM_LABELS.REMARK}
            label={ITEM_LABELS.REMARK}
            variant="outlined"
            size="small"
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />
        </Grid>
      </Grid>
    </Box>
  );

  const actions = (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        px: 2,
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            color="primary"
          />
        }
        label="I confirm that the above action is correct."
      />
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          variant="outlined"
          sx={styles.btn_secondary}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={styles.btn_primary}
          onClick={handleSubmit}
        disabled={!isChecked}
        >
          Ok
        </Button>
      </Box>
    </Box>
  );

  return (
    <PopUp
      open={open}
      handleClose={handleClose}
      title={getTitle()}
      content={content}
      actions={actions}
      maxWidth="sm"
    />
  );
};

export default ApprovalActionDialogreturn;
